<div class="container mt-10">
  <om-direct-signup (membershipTypeSelected)="typeSelected($event)"></om-direct-signup>
  <div class="text-center">
    <a class="btn btn-link" (click)="goToNextStep()" data-cy="done">I'm all done</a>
  </div>
</div>
